<p-dialog
  [(visible)]="visible"
  header="{{ 'current.meetings' | translate }}"
  [style]="{ 'min-width': '40vw', 'max-width': '80vw' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="p-0"
  (onHide)="onClose()">
  <div *ngFor="let meetingPointer of meetingPointers" class="mb-2 flex flex-col">
    <div
      class="cursor-pointer bg-gray-200 px-6 py-4 text-base font-semibold duration-200 hover:bg-gray-300"
      (click)="navigateToMeeting(meetingPointer.meetingId)">
      {{ meetingPointer.meetingStatusLabel }}
    </div>
    <p-button
      *ngIf="meetingPointer.activeAgendaPageId"
      (click)="navigateToSuiteView('meetingitem/view?id=' + meetingPointer.activeAgendaPageId)"
      class="p-button-link px-6 pt-2"
      styleClass="p-button-link no-underline">
      {{ meetingPointer.title }}
    </p-button>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button type="button" pButton label="{{ 'common.button.close' | translate }}" (click)="onClose()"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div
      class="p-dialog-header-icon"
      [title]="
        'dialog.button.close'
          | translate
            : {
                '0': 'current.meetings' | translate
              }
      ">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
